'use client';

import { ReactNode } from 'react';
import { usePathname } from 'next/navigation';
import dynamic from 'next/dynamic';
import { AuthProvider } from '@/components/auth/auth-context';

// Dynamically import Header with no SSR to avoid hydration issues
const Header = dynamic(() => import('@/components/layout/header').then(mod => mod.Header), { 
  ssr: false 
});

export function Providers({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  // Removed unused mounted state
  
  return (
    <AuthProvider>
      {/* Render header only on non-auth pages */}
      {!pathname.includes('/auth/') && <Header />}
      {children}
    </AuthProvider>
  );
}